<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
            <div class="row">
                <div class="col-12 col-md-6 my-2">
                    <kt-form-group>
                        <kt-form-label for="userid">
                            {{ $t('label.user_id') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" disabled aname="userid" id="userid" v-model="user.id"></kt-form-control>
                    </kt-form-group>
                </div>
            </div>
            <div class="line-divider mb-4"></div>
            <form v-if="status === 'success'" class="kt-form" @submit.prevent="update" id="profile_form">
                <kt-form-section is_first>
                    <kt-form-row>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="username">
                                    {{ $t('label.username_with_hint') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" name="username" id="username" v-model="user.username"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="email">
                                    {{ $t('label.email') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" name="email" id="email" v-model="user.email"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-form-row>
                    <kt-form-row>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="first_name">
                                    {{ $t('label.first_name') }}
                                </kt-form-label>
                                <kt-form-control name="first_name" id="first_name" v-model="user.first_name"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="first_name_en">
                                    {{ $t('label.first_name_en') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" name="first_name_en" id="first_name_en" v-model="user.first_name_en"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-form-row>

                    <kt-form-row>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="last_name">
                                    {{ $t('label.last_name') }}
                                </kt-form-label>
                                <kt-form-control name="last_name" id="last_name" v-model="user.last_name"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="last_name_en">
                                    {{ $t('label.last_name_en') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" name="last_name_en" id="last_name_en" v-model="user.last_name_en"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-form-row>

                    <kt-form-row>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="father_name">
                                    {{ $t('label.father_name') }}
                                </kt-form-label>
                                <kt-form-control name="father_name" id="father_name" v-model="user.father_name"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="father_name_en">
                                    {{ $t('label.father_name_en') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" name="father_name_en" id="father_name_en" v-model="user.father_name_en"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-form-row>

                    <kt-form-row>
                        <kt-col xs="12" sm="6" md="6">
                            <kt-form-group>
                                <kt-form-label for="birth_date">
                                    {{ $t('label.birth_date') }}
                                </kt-form-label>
                                <datePicker
                                        format="YYYY-MM-DD HH:mm:ss"
                                        display-format="dddd jDD jMMMM jYYYY"
                                        input-class="form-control"
                                        id="birth_date"
                                        name= "birth_date"
                                        v-model="user.birth_date"
                                        type="date" />
                            </kt-form-group>
                        </kt-col>
                        <kt-col xs="12" sm="6" md="6">
                            <kt-form-group>
                                <kt-form-label for="national_code">
                                    {{ $t('label.national_code') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" maxlength="10" name="national_code" id="national_code" v-model="user.national_code"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-form-row>
                </kt-form-section>

                <kt-form-section>
                    <kt-form-row>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="phone">
                                    {{ $t('label.phone') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" disabled name="phone" id="phone" :value="user.phone"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col>
                            <kt-form-group>
                                <kt-form-label for="telephone">
                                    {{ $t('label.telephone') }}
                                </kt-form-label>
                                <kt-form-control ref="telephone" dir="ltr" name="telephone" id="telephone" v-model="user.telephone">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-form-row>
                </kt-form-section>

                <kt-form-action class="mt-4" v-if="user.is_authenticated !== true">
                    <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                        {{ $t('btn.submit') }}
                    </button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
    <change-phone-number/>
</main-content>
</template>

<script>
import mainContent from './Base'
import $ from 'jquery'
import { mapState } from 'vuex'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { userService } from '@/common/api.service'
import Inputmask from 'inputmask'
import {i18n} from "@/plugins/i18n";
import ChangePhoneNumber from "@/views/profile/ChangePhoneNumber.vue";

export default {
    name: 'profile.update',
    components: {
        ChangePhoneNumber,
        'main-content': mainContent,
    },
    data: function() {
        return {
            user: this.$store.state.user.current_user,
            months: [
                {
                    title: i18n.t('month.farvardin'),
                    value: 1
                },
                {
                    title: i18n.t('month.ordibehesht'),
                    value: 2
                },
                {
                    title: i18n.t('month.khordad'),
                    value: 3
                },
                {
                    title: i18n.t('month.tir'),
                    value: 4
                },
                {
                    title: i18n.t('month.mordad'),
                    value: 5
                },
                {
                    title: i18n.t('month.shahrivar'),
                    value: 6
                },
                {
                    title: i18n.t('month.mehr'),
                    value: 7
                },
                {
                    title: i18n.t('month.aban'),
                    value: 8
                },
                {
                    title: i18n.t('month.azar'),
                    value: 9
                },
                {
                    title: i18n.t('month.day'),
                    value: 10
                },
                {
                    title: i18n.t('month.bahman'),
                    value: 11
                },
                {
                    title: i18n.t('month.esfand'),
                    value: 12
                },
            ],
        }
    },
    computed: {
        ...mapState('user', {
            status: state => state.status,
        })
    },
    watch: {
        status() {
            this.user = this.$store.state.user.current_user
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => vm.$store.dispatch('user/fetchCurrent').then(() => {
            vm.checkForDisableForm()
        }))
    },
    mounted() {
        this.$nextTick(function () {
            this.initialSetup()
        })
    },
    methods: {
        checkForDisableForm() {
            if (this.user.is_authenticated) {
                $("#profile_form :input").prop("disabled", true);
            }
        },
        initialSetup() {
            setTimeout(() => {
                document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'))
            }, 1000)
            
        },
        update(e) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    username: {
                        required: true,
                        minlength: 5
                    },
                    first_name: {
                        required: true,
                    },
                    last_name: {
                        required: true,
                    },
                    first_name_en: {
                        required: true,
                    },
                    last_name_en: {
                        required: true,
                    },
                    national_code: {
                        required: true,
                    },
                    birth_year: {
                        required: true,
                    },
                    birth_month: {
                        required: true,
                    },
                    birth_day: {
                        required: true,
                    },
                    telephone: {
                        required: true
                    },
                    phone: {
                        required: true
                    },
                    email: {
                        required: true
                    },
                },
            });


            if(!form.valid()) {
                return
            }

            if (!this.validateSocialId(this.user.national_code)) {
                form.validate().showErrors({
                    national_code: i18n.t('validation.invalid_national_code')
                })
                return;
            }
          //   this.user.forEach(item => {
          //     if (item === 'username' || item === 'first_name_en' || item === 'last_name_en' ) {
          //       if (!this.checkIfIsEnglish(item)) {
          //         form.validate().showErrors({
          //           [item]: i18n.t('pos.validations.enter_english')
          //         })
          //         return;
          //       }
          //     }
          //   })
          //
          // if (!this.checkIfIsPersian(this.user.father_name_fa)) {
          //   form.validate().showErrors({
          //     father_name_fa: i18n.t('pos.validations.enter_english')
          //   })
          //   return;
          // }

            let params = {
                username: this.user.username,
                first_name: this.user.first_name,
                first_name_en: this.user.first_name_en,
                last_name: this.user.last_name,
                last_name_en: this.user.last_name_en,
                father_name: this.user.father_name,
                father_name_en: this.user.father_name_en,
                national_code: this.user.national_code,
                birth_date: this.user.birth_date,
                phone: this.user.phone,
                telephone: this.user.telephone,
                email: this.user.email,
            }

            KTApp.progress(btn)
            userService.update(params)
            .then(response => {
                this.$store.commit('user/success', response.data.data)
                this.showMsg(form, 'success', response.data.message)
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        },
        getYear() {
            return new Date().getFullYear() - 721
        },
        validateSocialId(social_id) {
            var L=social_id.length;

            if(L<8 || parseInt(social_id,10)==0) return false;
            social_id=('0000'+social_id).substr(L+4-10);
            if(parseInt(social_id.substr(3,6),10)==0) return false;
            var c=parseInt(social_id.substr(9,1),10);
            var s=0;
            for(var i=0;i<9;i++)
                s+=parseInt(social_id.substr(i,1),10)*(10-i);
            s=s%11;
            return (s<2 && c==s) || (s>=2 && c==(11-s));
        },
    }
}
</script>

<style>
.kt-nav .kt-nav__item > .router-link-exact-active {
    background-color: #f7f8fa!important;
}
.router-link-exact-active > .kt-nav__link-icon,
.router-link-exact-active > .kt-nav__link-text {
    color: #5d78ff!important;
}
</style>